import ReactTable from 'react-table'
import * as S from './Table.styles'

interface Columns {
  Header: string
  id: string
  accessor: string
  width: number
}

interface Props {
  id?: string
  data: any[]
  columns: Columns[]
  onRowDoubleClick?: any
  className?: string
  pageSize?: number
  testId?: string
}

export default ({
  id = '', data, className, columns, onRowDoubleClick, pageSize = 15, testId,
}: Props) => {
  const getPageSize = !data.length || data.length < pageSize ? pageSize : data.length

  const customColumns = columns.map((column) => ({
    ...column,
    Header: <S.HeaderCell>{column.Header}</S.HeaderCell>,
  }))

  return (
    <S.Wrapper id={id} className={className} data-testid={testId}>
      <ReactTable
        style={{
          fontSize: '0.7rem',
          maxWidth: '100%',
          width: '100%',
          height: '100%',
          overflowX: 'auto',
        }}
        data={data}
        columns={customColumns}
        showPaginationBottom={false}
        pageSize={getPageSize}
        className='-striped -highlight'
        getTrProps={onRowDoubleClick}
        previousText={false}
        nextText={false}
        loadingText='Carregando...'
        noDataText='Sem registros'
        pageText='Página'
        ofText='de'
        rowsText='Registros'
      />
    </S.Wrapper>
  )
}
